import apiClient from './apiClient';

export const outlookCalendarApi = {
  getStatus: async () => {
    const response = await apiClient.get('/auth/outlook-cal/status');
    return response.data;
  },

  getAuthUrl: async () => {
    const response = await apiClient.get('/auth/outlook-cal');
    return response.data;
  },

  disconnect: async () => {
    const response = await apiClient.delete('/auth/outlook-cal');
    return response.data;
  },

  importEvents: async () => {
    const response = await apiClient.post('/auth/outlook-cal/import');
    return response.data;
  }
};
